import React from 'react';
import { CheckCircle2Icon, XOctagonIcon } from 'lucide-react';
export function WhoIsFor() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-292">
      <div className="max-w-6xl mx-auto" data-id="element-293">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-294">
          {/* Who is FOR */}
          <div className="bg-brand-card border border-brand-green/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-295">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-green/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-296" />

            <h3 className="text-3xl font-bold text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-297">
              <CheckCircle2Icon className="w-8 h-8 text-brand-green" data-id="element-298" />
              ESTO ES PARA TI SI:
            </h3>

            <ul className="space-y-5 relative z-10" data-id="element-299">
              {['Estás cansado de perder dinero siguiendo picks que no entiendes.', 'Quieres dejar de depender de tipsters y empezar a pensar por tu cuenta.', 'Buscas convertir las apuestas en un sistema, no en suerte.', 'Quieres tener control real sobre tus decisiones.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-300">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-green shrink-0 mt-0.5" data-id="element-301" />
                  <span className="text-lg text-brand-muted" data-id="element-302">{text}</span>
                </li>)}
            </ul>
          </div>

          {/* Who is NOT FOR */}
          <div className="bg-brand-card border border-brand-red/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-303">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-red/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-304" />

            <h3 className="text-3xl font-bold text-brand-text mb-8 flex items-center gap-3 relative z-10" data-id="element-305">
              <XOctagonIcon className="w-8 h-8 text-brand-red" data-id="element-306" />
              ESTO NO ES PARA TI SI:
            </h3>

            <ul className="space-y-5 relative z-10" data-id="element-307">
              {['Buscas dinero rápido sin analizar.', 'Necesitas que alguien te diga exactamente qué apostar.', 'Prefieres seguir señales en lugar de entender lo que haces.', 'Crees en "fijas" o resultados asegurados.'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-308">
                  <XOctagonIcon className="w-6 h-6 text-brand-red shrink-0 mt-0.5" data-id="element-309" />
                  <span className="text-lg text-brand-muted" data-id="element-310">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Closing Statement */}
        <div className="mt-12 text-center" data-id="element-311">
          <p className="text-2xl md:text-3xl text-brand-gold font-bold" data-id="element-312">
            BetIQ está diseñado para personas que quieren control, no excusas.
          </p>
        </div>
      </div>
    </section>;
}